/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementCreateEventResponse } from './EventManagementCreateEventResponse';

export type EventManagementCreateEventResponseApiRespoonse = {
    data?: EventManagementCreateEventResponse;
    status?: EventManagementCreateEventResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementCreateEventResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

